export const SHORT_SCAN_CHECK_TYPE = ["CI", "DF", "RB"];
export const SCAN_CHECK_TYPE = [
    "artifact-check",
    "repro-check",
    "artifact-diff",
];
export const SCAN_TYPE = ["scan-version", "scan-repro"];
export const RISK_SUPER_CATEGORIES = [
    "compliance",
    "security",
    "threats",
];
export const POLICY_CATEGORY_LIST = [
    "containers",
    "diff-hunting",
    "hunting",
    "hardening",
    "integrity",
    "licenses",
    "secrets",
    "signatures",
    "threats",
    "vulnerabilities",
    "yara",
];
export const REPORT_EXPORTS = {
    cve: "RL-CVE",
    cycloneDX: "CycloneDX",
    json: "RL-JSON",
    safe: "RL-SAFE",
    sarif: "Sarif",
    spdx: "SPDX",
    summaryPdf: "PDF",
    uri: "RL-URI",
};
//# sourceMappingURL=constants.js.map